export const caseTaxToggle = () => {

    const updateCounts = () => {

        const wrappers = document.querySelectorAll('.case-card-categories');

        wrappers.forEach(wrapper => {

            const cats = wrapper.querySelectorAll('.case-card-categories__cat');
            const moreBtn = wrapper.querySelector('.case-card-categories__more');

            if (!moreBtn) return;

            const total = cats.length;

            let visible = 2;

            if (window.innerWidth <= 767) {
                visible = 1;
            }

            const hiddenCount = total - visible;

            if (hiddenCount > 0) {
                moreBtn.textContent = '+' + hiddenCount;
                moreBtn.style.display = 'inline-block';
            } else {
                moreBtn.style.display = 'none';
            }

        });

    };

    document.addEventListener('DOMContentLoaded', () => {

        updateCounts();

        document.querySelectorAll('.case-card-categories__more').forEach(btn => {

            btn.addEventListener('click', function () {

                const wrapper = this.closest('.case-card-categories');

                wrapper.classList.toggle('is-open');

                if(wrapper.classList.contains('is-open')){
                    this.style.display = 'none';
                }

            });

        });

    });

    window.addEventListener('resize', updateCounts);

};